import { Array, Record } from 'effect'
import { isNotNullish } from 'effect/Predicate'

import type { PolicyAction } from './action.ts'
import { createdByAttributePolicyDefinition } from './defaultPolicies/createdByAttributePolicyDefinition.ts'
import { managerRolePolicyDefinition } from './defaultPolicies/managerRolePolicyDefinition.ts'
import { memberRolePolicyDefinition } from './defaultPolicies/memberRolePolicyDefinition.ts'
import { minimalRolePolicyDefinition } from './defaultPolicies/minimalRolePolicyDefinition.ts'
import { nxMemberRolePolicyDefinition } from './defaultPolicies/nxMemberRolePolicyDefinition.ts'
import { playingManagerRolePolicyDefinition } from './defaultPolicies/playingManagerRolePolicyDefinition.ts'
import type { Policy, PolicyUserRole } from './schema.ts'

// デフォルトで指定されるポリシー
const defaultPolicies = [
  //
  // ロールごとのポリシー宣言
  //
  ...Record.collect(managerRolePolicyDefinition, (action, permission) =>
    createRolePolicy('manager', action, permission),
  ),
  ...Record.collect(playingManagerRolePolicyDefinition, (action, permission) =>
    createRolePolicy('playingManager', action, permission),
  ),
  ...Record.collect(memberRolePolicyDefinition, (action, permission) => createRolePolicy('member', action, permission)),
  ...Record.collect(minimalRolePolicyDefinition, (action, permission) =>
    createRolePolicy('minimal', action, permission),
  ),
  // nx様対応
  ...Record.collect(nxMemberRolePolicyDefinition, (action, permission) =>
    createRolePolicy('nxMember', action, permission),
  ),
  ...Record.collect(createdByAttributePolicyDefinition, (action, permission) =>
    permission === undefined ? undefined : createUserAttributePolicy('createdBy', action, permission),
  ),
].filter(isNotNullish)

// abilityのロジックで使うのは、actionをkeyとしたRecord型
export const defaultPoliciesMapper: Partial<Record<PolicyAction, Policy[]>> = Array.groupBy(
  defaultPolicies,
  (x) => x.action,
)

function createRolePolicy(role: PolicyUserRole, action: PolicyAction, permission: boolean): Policy {
  return {
    principal: {
      type: `userRole`,
      role,
    },
    action,
    permission,
  }
}

function createUserAttributePolicy(attributeType: 'createdBy', action: PolicyAction, permission: boolean): Policy {
  return {
    principal: {
      type: `userAttribute`,
      attributeType,
    },
    action,
    permission,
  }
}
